import React, { forwardRef } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

interface OptimizedImageProps {
  src: string;
  alt: string;
  className?: string;
  size?: {
    width: number;
    height: number;
    quality: number;
    format: 'webp';
  };
  priority?: boolean;
  style?: React.CSSProperties;
}

const OptimizedImage = forwardRef<HTMLDivElement, OptimizedImageProps>(
  ({ src, alt, className = '', priority = false, style }, ref) => {
    return (
      <div ref={ref} className={className} style={style}>
        <LazyLoadImage
          src={src}
          alt={alt}
          effect="blur"
          width="100%"
          height="100%"
          threshold={50}
          visibleByDefault={priority}
          style={{ objectFit: 'cover', width: '100%', height: '100%' }}
        />
      </div>
    );
  }
);

OptimizedImage.displayName = 'OptimizedImage';

export default OptimizedImage;